import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { SkipByRefreshTokenInterceptor } from '@core/http/tokens/skip-by-refresh-token-interceptor';
import { SkipByAuthInterceptor } from '@core/http/tokens/skip-by-auth-interceptor';
import { SkipByLoadingInterceptor } from '@core/http/tokens/skip-by-loading-interceptor';

@Injectable({
  providedIn: 'root',
})
export class HttpContextBuilder {
  private context = new HttpContext();

  constructor() {
    this.reset();
  }

  reset(): this {
    this.context = new HttpContext();

    return this;
  }

  skipByAuthToken(): this {
    this.context.set(SkipByAuthInterceptor, true);

    return this;
  }

  skipByRefreshToken(): this {
    this.context.set(SkipByRefreshTokenInterceptor, true);

    return this;
  }

  skipByLoadingToken(): this {
    this.context.set(SkipByLoadingInterceptor, true);

    return this;
  }

  build(): HttpContext {
    const context = this.context;

    this.reset();

    return context;
  }
}
